/**
 * DetailForwardingLocation
 * --
 */
import { useEffect, useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  // InputFormTable,
  // ModalLayout,
  Text,
} from 'components';
import {
  Input,
  Button,
  // Rate,
  // Avatar,
  Radio,
  Descriptions,
  // Space,
  Select,
  // Switch,
  Spin,
  // Divider,
  DatePicker,
  InputNumber,
  Flex,
} from 'antd';
import MessageAlert, { stringToMoneyFormat } from 'utils';
import { ForwardingLocationApi, StatisticsApi } from 'api';
import DeliveryCompany from 'constants/DeliveryCompany';
import moment from 'moment';
import { openAddressModal } from 'utils/DaumAPIManager';
import dayjs from 'dayjs';
import RemoteAreaModal from './RemoteAreaModal';
import { FORWARDING_TYPE } from 'constants/ForwardingConstants';

const DELIVERY_METHOD = {
  PARCEL: '택배',
  REGISTERED: '등기',
  PACKAGE: '소포',
};

const initData = {
  forwarding_name: '',
  receive_information: {
    manager_name: '',
    business_hour: '',
    pickup_available_date: null,
    pickup_location_map: '',
    pickup_instruction: '',
  },
  phone: '',
  forwarding_postcode: '',
  forwarding_address: '',
  forwarding_address_detail: '',

  delivery_company: 'CJGLS',

  type: 'FORWARD', //
};

/**----------------------------------------
 * [Component] 총관리자: 리뷰상세 - Presenter
 * ----------------------------------------
 */
const DetailForwardingLocation = ({
  defaultData,
  defaultEditMode,
  currentShop,
  onSaved,
}) => {
  /* ===== PROPS ===== */

  /* ===== STATE ===== */
  const [loading, setLoading] = useState(false);
  const [, setEditId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState(initData);

  const [isOpened, setIsOpened] = useState(false);

  /* ===== VARIABLE ===== */

  /**--------------------
   * 다음 주소 검색 Popup Open
   * --------------------
   */
  const handleOpen = (keys) => {
    openAddressModal((res) => {
      setData({
        ...data,
        ...Object.entries(keys).reduce((acc, [key, value]) => {
          acc[key] = res[value];

          return acc;
        }, {}),
      });
    });
  };

  /**
   *
   * --
   */
  const onChangeData = (key, value) => {
    setData((p) => ({ ...p, [key]: value }));
  };
  const onChangeRemoteData = (key, value) => {
    const remote = data?.['remote_area_postcode'] ?? [];

    const fid = remote.findIndex((item) => item.key === key);

    if (fid === -1) return;

    const newData = [
      ...remote.slice(0, fid),
      { ...remote[fid], price: value },
      ...remote.slice(fid + 1),
    ];

    onChangeData('remote_area_postcode', newData);
  };
  /**
   *
   * --
   */
  const onChangeDataReceive = (key, value) => {
    setData((p) => ({
      ...p,
      receive_information: {
        ...p.receive_information,
        [key]: value,
      },
    }));
  };

  /**
   *
   * --
   */
  const handleSave = async () => {
    setLoading(true);
    try {
      // 예외처리
      if (
        !data ||
        !data.forwarding_name ||
        !data.receive_information ||
        !data.receive_information.manager_name ||
        !data.forwarding_address
      ) {
        setLoading(false);
        return MessageAlert.warning('필수정보를 입력해주세요');
      }

      let result;
      // 수정모드
      if (editMode && data?.forwarding_location_id) {
        result = await ForwardingLocationApi.updateForwardingLocation({
          ...data,
          shop_information_id: currentShop,
        });
      }
      // 생성모드
      else {
        result = await ForwardingLocationApi.createForwardingLocation({
          ...data,
          shop_information_id: currentShop,
        });
      }

      const { status, message } = result;
      if (status !== 200) throw { message };

      const newData = data?.shop_information_id
        ? data
        : { ...data, forwarding_location_id: result.forwarding_location_id };

      setTimeout(() => {
        // setLoading(data);
        MessageAlert.info('저장되었습니다.');
        setLoading(false);
        setEditId(null);
        setEditMode(false);
        setData(newData);
        onSaved(newData, false);
      }, 500);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /**
   *
   * --
   */
  const handleDelete = async () => {
    const check = await StatisticsApi.getForeignKeyCheck({
      columnName: 'forwarding_location_id',
      value: data?.forwarding_location_id,
    });

    if (check.status !== 200 || !check.data) {
      MessageAlert.info(
        `${data?.forwarding_name} 출고지를 참고하고있는 데이터가 있어 삭제할 수 없습니다.`
      );
      return;
    }

    if (
      !window.confirm('삭제 시 데이터를 복구할 수 없습니다.\n삭제하시겠습니까?')
    )
      setLoading(true);
    try {
      const { status, message } =
        await ForwardingLocationApi.deleteForwardingLocation(
          data?.forwarding_location_id
        );
      if (status !== 200) throw { message };

      MessageAlert.info('삭제되었습니다.');
      setLoading(false);
      onSaved(data?.forwarding_location_id, true);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  useEffect(() => {
    setEditMode(defaultEditMode);
  }, [defaultEditMode]);
  useEffect(() => {
    defaultData && setData(defaultData);
  }, [defaultData]);
  useEffect(() => {
    return () => {
      setData(initData);
    };
  }, []);

  /* ===== RENDER ===== */
  return (
    <>
      <Spin spinning={loading}>
        <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
          <Row>
            <Col x={24}>
              {/* <Title size={4} style={{ ...styles.title }}>
              리뷰 상세정보
            </Title> */}

              {/* 기본정보 */}
              <Content
                maxWidth={'100%'}
                padding={0}
                borderRadius={4}
                style={{ marginBottom: 20 }}
              >
                {/* ===== 상품정보 - start ===== */}
                <Title
                  size={5}
                  subButton={
                    <Button
                      color="danger"
                      variant="filled"
                      size="small"
                      onClick={handleDelete}
                    >
                      출고지삭제
                    </Button>
                  }
                >
                  출고/수령지 정보
                </Title>
                <Descriptions
                  size="small"
                  bordered
                  column={2}
                  labelStyle={{
                    width: 125,
                    color: '#111',
                    fontWeight: '500',
                    background: '#f4f4f4',
                  }}
                  style={{
                    borderTop: '2px solid #d1d1d1',
                    borderRadius: 5,
                    marginTop: 5,
                  }}
                  items={[
                    {
                      key: 'type',
                      label: (
                        <p>
                          유형 <span style={{ color: '#FF4242' }}>*</span>
                        </p>
                      ),
                      required: true,
                      children: editMode ? (
                        <Radio.Group
                          value={data?.type}
                          onChange={(e) => onChangeData('type', e.target.value)}
                        >
                          <Radio value={'FORWARD'}>출고지</Radio>
                          <Radio value={'RECEIVE'}>수령지</Radio>
                        </Radio.Group>
                      ) : (
                        `${FORWARDING_TYPE[data?.type]?.label}`
                      ),
                    },
                    {
                      key: 'forwarding_name',
                      label: (
                        <p>
                          출고지명 <span style={{ color: '#FF4242' }}>*</span>
                        </p>
                      ),
                      span: 2,
                      children: editMode ? (
                        <Input
                          placeholder="출고지명을 입력해주세요"
                          value={data.forwarding_name}
                          onChange={(e) =>
                            onChangeData('forwarding_name', e.target.value)
                          }
                        />
                      ) : (
                        data?.forwarding_name
                      ),
                    },

                    /* === Line 2 === */
                    {
                      key: 'phone',
                      label: (
                        <p>
                          대표연락처 <span style={{ color: '#FF4242' }}>*</span>
                        </p>
                      ),
                      children: editMode ? (
                        <Input
                          placeholder="대표연락처를 입력해주세요"
                          value={data.phone}
                          onChange={(e) =>
                            onChangeData('phone', e.target.value)
                          }
                        />
                      ) : (
                        data?.phone
                      ),
                    },
                    {
                      key: 'manager_name',
                      label: (
                        <p>
                          담당자명 <span style={{ color: '#FF4242' }}>*</span>
                        </p>
                      ),
                      children: editMode ? (
                        <Input
                          placeholder="담당자명을 입력해주세요"
                          value={data?.receive_information?.manager_name}
                          onChange={(e) =>
                            onChangeDataReceive('manager_name', e.target.value)
                          }
                        />
                      ) : (
                        data?.receive_information?.manager_name
                      ),
                    },

                    /* === Line 3 === */
                    {
                      key: 'business_hour',
                      label: '영업시간',
                      span: 2,
                      children: editMode ? (
                        <Input
                          placeholder="영업시간을 입력해주세요"
                          value={data?.receive_information?.business_hour}
                          onChange={(e) =>
                            onChangeDataReceive('business_hour', e.target.value)
                          }
                        />
                      ) : (
                        data?.receive_information?.business_hour
                      ),
                    },
                    {
                      key: 'delivery_method',
                      label: (
                        <p>
                          배송방법 <span style={{ color: '#FF4242' }}>*</span>
                        </p>
                      ),
                      span: 1,
                      children: editMode ? (
                        <Select
                          style={{ width: 150 }}
                          placeholder="배송방법"
                          options={Object.entries(DELIVERY_METHOD).map(
                            ([key, value]) => ({
                              label: value,
                              value: key,
                            })
                          )}
                          value={data.delivery_method}
                          onChange={(e) => onChangeData('delivery_method', e)}
                        />
                      ) : (
                        DELIVERY_METHOD[data?.delivery_method]
                      ),
                    },
                    {
                      key: 'delivery_company',
                      label: (
                        <p>
                          택배사 <span style={{ color: '#FF4242' }}>*</span>
                        </p>
                      ),
                      span: 1,
                      children: editMode ? (
                        <Select
                          style={{ width: 150 }}
                          placeholder="택배사"
                          options={Object.keys(DeliveryCompany).map((item) => ({
                            value: DeliveryCompany[item].value,
                            label: DeliveryCompany[item].label,
                          }))}
                          value={data.delivery_company}
                          onChange={(e) => onChangeData('delivery_company', e)}
                          showSearch
                          optionFilterProp="label"
                        />
                      ) : (
                        DeliveryCompany[data?.delivery_company]?.label
                      ),
                    },
                    {
                      key: 'delivery_price',
                      label: (
                        <p>
                          배송비 <span style={{ color: '#FF4242' }}>*</span>
                        </p>
                      ),
                      span: 1,
                      children: editMode ? (
                        <InputNumber
                          placeholder="배송비"
                          value={data.delivery_price}
                          onChange={(e) => onChangeData('delivery_price', e)}
                          min={0}
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                          }
                          style={{ width: '100%' }}
                          suffix={'원'}
                        />
                      ) : (
                        stringToMoneyFormat(data?.delivery_price)
                      ),
                    },
                    {
                      key: 'free_delivery_price',
                      label: (
                        <p>
                          무료배송기준{' '}
                          <span style={{ color: '#FF4242' }}>*</span>
                        </p>
                      ),
                      span: 1,
                      children: editMode ? (
                        <InputNumber
                          placeholder="무료배송 기준금액"
                          value={data.free_delivery_price}
                          onChange={(e) =>
                            onChangeData('free_delivery_price', e)
                          }
                          min={0}
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                          }
                          style={{ width: '100%' }}
                          suffix={'원 이상'}
                        />
                      ) : (
                        stringToMoneyFormat(data?.free_delivery_price)
                      ),
                    },
                    {
                      key: 'return_price',
                      label: (
                        <p>
                          반품배송비 <span style={{ color: '#FF4242' }}>*</span>
                        </p>
                      ),
                      span: 1,
                      children: editMode ? (
                        <InputNumber
                          placeholder="반품배송비 (편도)"
                          value={data.return_price}
                          onChange={(e) => onChangeData('return_price', e)}
                          min={0}
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                          }
                          style={{ width: '100%' }}
                          suffix={'원'}
                        />
                      ) : (
                        stringToMoneyFormat(data?.delivery_price)
                      ),
                    },
                    {
                      key: 'exchange_price',
                      label: (
                        <p>
                          교환배송비 <span style={{ color: '#FF4242' }}>*</span>
                        </p>
                      ),
                      span: 1,
                      children: editMode ? (
                        <InputNumber
                          placeholder="교환배송비 (왕복)"
                          value={data.exchange_price}
                          onChange={(e) => onChangeData('exchange_price', e)}
                          min={0}
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                          }
                          style={{ width: '100%' }}
                          suffix={'원'}
                        />
                      ) : (
                        stringToMoneyFormat(data?.delivery_price)
                      ),
                    },
                    {
                      key: 'pickup_available_date',
                      label: '수령가능일',
                      span: 2,
                      children: editMode ? (
                        <>
                          <DatePicker
                            placeholder="날짜를 선택해주세요"
                            style={{ width: 165 }}
                            defaultValue={
                              data?.receive_information?.pickup_available_date
                                ? dayjs(
                                    data?.receive_information
                                      ?.pickup_available_date
                                  )
                                : null
                            }
                            onChange={(_, d) =>
                              onChangeDataReceive(
                                'pickup_available_date',
                                moment(d).unix
                              )
                            }
                          />{' '}
                          부터 수령가능
                        </>
                      ) : (
                        data?.receive_information?.pickup_available_date
                      ),
                    },
                    {
                      key: 'forwarding_address',
                      label: (
                        <p>
                          주소 <span style={{ color: '#FF4242' }}>*</span>
                        </p>
                      ),
                      span: 2,
                      children: editMode ? (
                        <>
                          <div>
                            <Input
                              placeholder="주소를 입력해주세요"
                              value={data?.forwarding_address}
                              // onChange={onChangeData}
                              style={{ width: '80%', marginBottom: 5 }}
                              disabled={true}
                            />{' '}
                            <Button
                              onClick={() =>
                                handleOpen({
                                  forwarding_postcode: 'zonecode',
                                  forwarding_address: 'address',
                                })
                              }
                            >
                              찾기
                            </Button>
                            <br />
                            <Input
                              placeholder="상세주소를 입력해주세요"
                              value={data?.forwarding_address_detail}
                              onChange={(e) =>
                                onChangeData(
                                  'forwarding_address_detail',
                                  e.target.value
                                )
                              }
                              style={{ width: '100%' }}
                            />{' '}
                          </div>
                        </>
                      ) : (
                        `(${data?.forwarding_postcode}) ${data?.forwarding_address} ${data?.forwarding_address_detail}`
                      ),
                    },
                    {
                      key: 'return_address',
                      label: '반품/교환 주소',
                      span: 2,
                      children: editMode ? (
                        <>
                          <div>
                            <Input
                              placeholder="주소를 입력해주세요"
                              value={data?.return_address}
                              // onChange={onChangeData}
                              style={{ width: '80%', marginBottom: 5 }}
                              disabled={true}
                            />{' '}
                            <Button
                              onClick={() =>
                                handleOpen({
                                  return_postcode: 'zonecode',
                                  return_address: 'address',
                                })
                              }
                            >
                              찾기
                            </Button>
                            <br />
                            <Input
                              placeholder="상세주소를 입력해주세요"
                              value={data?.return_address_detail}
                              onChange={(e) =>
                                onChangeData(
                                  'return_address_detail',
                                  e.target.value
                                )
                              }
                              style={{ width: '100%' }}
                            />{' '}
                          </div>
                        </>
                      ) : (
                        `(${data?.return_postcode ?? '-'}) ${
                          data?.return_address ?? '-'
                        } ${data?.return_address_detail ?? '-'}`
                      ),
                    },
                    {
                      key: 'pickup_instruction',
                      label: '안내',
                      span: 2,
                      children: editMode ? (
                        <Input
                          placeholder="안내를 입력해주세요"
                          value={data?.receive_information?.pickup_instruction}
                          onChange={(e) =>
                            onChangeDataReceive(
                              'pickup_instruction',
                              e.target.value
                            )
                          }
                        />
                      ) : (
                        data?.receive_information?.pickup_instruction
                      ),
                    },

                    {
                      key: 'remote_area_postcode',
                      label: '도서산간지역',
                      span: 2,
                      children: editMode ? (
                        <Flex vertical gap={10}>
                          <Button
                            size="small"
                            style={{ width: 50 }}
                            onClick={() => setIsOpened(!isOpened)}
                          >
                            추가
                          </Button>

                          {data?.remote_area_postcode?.map((area) => (
                            <Flex key={`remote-${area.key}`} align="center">
                              <Flex gap={4} flex={1}>
                                <Text>{area.city}</Text>
                                <Text>
                                  [{area.range[0]} - {area.range[1]}]
                                </Text>
                              </Flex>

                              <InputNumber
                                value={area.price}
                                onChange={(e) =>
                                  onChangeRemoteData(area.key, e)
                                }
                                min={0}
                                formatter={(value) =>
                                  `${value}`.replace(
                                    /\B(?=(\d{3})+(?!\d))/g,
                                    ','
                                  )
                                }
                                style={{ width: 150 }}
                                suffix={'원'}
                              />
                            </Flex>
                          ))}
                        </Flex>
                      ) : (
                        <Flex vertical>
                          {data?.remote_area_postcode
                            ? data?.remote_area_postcode?.map((area) => (
                                <Flex
                                  key={`remote-${area.key}`}
                                  align="center"
                                  justify="space-between"
                                  gap={4}
                                >
                                  <Flex gap={4}>
                                    <p>{area.city}</p>
                                    <p>
                                      [{area.range[0]} - {area.range[1]}]
                                    </p>
                                  </Flex>
                                  <p>{stringToMoneyFormat(area.price, '원')}</p>
                                </Flex>
                              ))
                            : '-'}
                        </Flex>
                      ),
                    },

                    // {
                    //   key: 'pickup_location_map',
                    //   label: '약도',
                    //   span: 2,
                    //   children: '',
                    //   children: editMode ? (
                    //     <Input
                    //       placeholder=""
                    //       value={data?.receive_information?.pickup_location_map}
                    //       onChange={(e) =>
                    //         onChangeDataReceive(
                    //           'pickup_location_map',
                    //           e.target.value
                    //         )
                    //       }
                    //     />
                    //   ) : (
                    //     data?.receive_information?.pickup_location_map
                    //   ),
                    // },
                  ]}
                />
                {/* ===== 상품정보 - start ===== */}

                <br />
                <div style={{ width: '100%', textAlign: 'center' }}>
                  {editMode === true ? (
                    <>
                      <Button
                        onClick={() => {
                          setEditMode(false);
                          setEditId(null);
                        }}
                      >
                        취소
                      </Button>{' '}
                      <Button type="primary" onClick={handleSave}>
                        저장
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        type="primary"
                        onClick={() => {
                          setEditMode(true);
                          setEditId(
                            defaultData
                              ? defaultData.forwarding_location_id
                              : null
                          );
                        }}
                      >
                        편집
                      </Button>
                    </>
                  )}
                </div>
              </Content>
              {/* 기본정보 끝 */}

              {/* 버튼 끝 */}
            </Col>
          </Row>
        </Content>
      </Spin>

      <RemoteAreaModal
        isOpened={isOpened}
        onClose={() => setIsOpened(!isOpened)}
        onOk={(data) => onChangeData('remote_area_postcode', data)}
        data={data?.remote_area_postcode ?? []}
      />
    </>
  );
};

DetailForwardingLocation.defaultProps = {
  currentShop: null,
  defaultData: null,
  defaultEditMode: false,
  onChangeEditMode: () => {},
  onSaved: () => {},
};

export default DetailForwardingLocation;
